import { apiClient } from 'api/client/apiClient';
import { RepositoryDTO } from '../types';
import { API_URLS } from '../consts';

export const fetchRepositories = async () => {
  const result = await apiClient.get<RepositoryDTO[]>(`${API_URLS.Repositories}/repositories`);

  return result.data;
};
